import { defineStore } from 'pinia';
import { ref } from 'vue';
import { api } from '@/utils/api';

const STORAGE_KEY = 'quark-vault-token';

export const useAuthStore = defineStore('auth', () => {
  const token = ref(localStorage.getItem(STORAGE_KEY) || '');
  const username = ref(localStorage.getItem(`${STORAGE_KEY}:user`) || '');
  const displayName = ref(localStorage.getItem(`${STORAGE_KEY}:name`) || username.value);

  function setSession(result: { token: string; user: { username: string; displayName?: string } }) {
    token.value = result.token;
    username.value = result.user.username;
    displayName.value = result.user.displayName || result.user.username;
    localStorage.setItem(STORAGE_KEY, token.value);
    localStorage.setItem(`${STORAGE_KEY}:user`, username.value);
    localStorage.setItem(`${STORAGE_KEY}:name`, displayName.value);
  }

  async function login(loginName: string, password: string) {
    const result = await api<{ token: string; user: { username: string; displayName?: string } }>('/auth/login', { method: 'POST', body: { username: loginName, password }, anonymous: true });
    setSession(result);
  }

  function logout() {
    token.value = '';
    username.value = '';
    displayName.value = '';
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(`${STORAGE_KEY}:user`);
    localStorage.removeItem(`${STORAGE_KEY}:name`);
  }

  return { token, username, displayName, setSession, login, logout };
});
